import React from 'react';
import { Card } from '../ui/card';
import { Wifi, UserCheck, Users, UserX, HelpCircle } from 'lucide-react';

const Kpi = ({ icon: Icon, label, value, hint, tone = 'text-slate-900', testid, delay }) => (
  <Card className="p-4 bg-white border-slate-200 act-rise" style={{ animationDelay: `${delay}ms` }}>
    <div className="flex items-start justify-between gap-3">
      <div>
        <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-slate-500">{label}</p>
        <p className={`mt-1 text-3xl font-extrabold tabular-nums ${tone}`} style={{ fontFamily: 'Manrope, sans-serif' }} data-testid={testid}>{value}</p>
        {hint && <p className="text-[11px] text-slate-400 mt-0.5">{hint}</p>}
      </div>
      <Icon className="h-7 w-7 text-slate-200 shrink-0" />
    </div>
  </Card>
);

export const ActividadKpis = ({ kpis, dias }) => (
  <div className="grid grid-cols-2 lg:grid-cols-5 gap-4" data-testid="act-kpis">
    <Kpi icon={Wifi} label="En línea ahora" value={kpis.en_linea} hint="Últimos 5 minutos" tone="text-emerald-700" testid="act-kpi-en-linea" delay={0} />
    <Kpi icon={UserCheck} label="Activos hoy" value={kpis.hoy} hint={`de ${kpis.usuarios} usuarios`} testid="act-kpi-hoy" delay={60} />
    <Kpi icon={Users} label="Activos en el período" value={kpis.en_periodo} hint={dias === 1 ? 'Hoy' : `Últimos ${dias} días`} testid="act-kpi-periodo" delay={120} />
    <Kpi icon={UserX} label="Inactivos +7 días" value={kpis.inactivos} tone={kpis.inactivos ? 'text-amber-700' : 'text-slate-900'} testid="act-kpi-inactivos" delay={180} />
    <Kpi icon={HelpCircle} label="Sin registro" value={kpis.sin_registro} hint="Nunca registraron actividad" tone="text-slate-500" testid="act-kpi-sin-registro" delay={240} />
  </div>
);

export default ActividadKpis;
